import { render, staticRenderFns } from "./warehouses.vue?vue&type=template&id=138deed2&"
import script from "./warehouses.vue?vue&type=script&lang=js&"
export * from "./warehouses.vue?vue&type=script&lang=js&"
import style0 from "./warehouses.vue?vue&type=style&index=0&id=138deed2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports